import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "p-tab",
  props: {
    selectTab: null,
    tab: null,
    tabActiveColor: {
      type: String,
      default: "#2963ef"
    },
    width: {
      type: String,
      default: "auto"
    },
    type: {
      type: String,
      default: "grid"
    }
  },
  computed: {
    ...walletVuex.mapState(["isMobile"])
  },
  data() {
    return {};
  },
  methods: {
    onTab(item) {
      this.setSelectTab(item.value);
    },
    setSelectTab(val) {
      this.$emit("update:selectTab", val);
      console.log("selectTab", this.selectTab);
    }
  },
  mounted() {
    this.setSelectTab(this.tab[0].value);
  }
};